"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _tour = require("@/api/tour");
var _ListOrder = _interopRequireDefault(require("@/views/home/components/ListOrder.vue"));
var _SummaryTour = _interopRequireDefault(require("@/views/home/components/SummaryTour.vue"));
var _TourForm = _interopRequireDefault(require("@/views/home/components/TourForm.vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var TourModal = /*#__PURE__*/function (_Vue) {
  function TourModal() {
    var _this;
    (0, _classCallCheck2.default)(this, TourModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, TourModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      dataTable: [],
      moneyReturnCustomer: 0
    });
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(TourModal, _Vue);
  return (0, _createClass2.default)(TourModal, [{
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$refs.tourForm.$refs.form.validate();
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", this.$message.error("Fill correct all input"));
            case 8:
              _context.prev = 8;
              this.loadingButton = true;
              _context.next = 12;
              return _tour.tourApi.update(this.form.id, {
                tour: (0, _objectSpread2.default)({}, this.form),
                shipperIds: this.form.shipperIds,
                orderIds: this.form.dataTable.map(function (e) {
                  return e.id;
                })
              });
            case 12:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 15:
              _context.prev = 15;
              this.loadingButton = false;
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 5], [8,, 15, 18]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleEdit",
    value: function handleEdit(data) {
      this.visible = true;
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        dataTable: data.orders,
        shipperIds: data.shippers.map(function (e) {
          return e.id;
        })
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
TourModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ListOrder: _ListOrder.default,
    SummaryTour: _SummaryTour.default,
    TourForm: _TourForm.default
  }
})], TourModal);
var _default = exports.default = TourModal;